import api from './utils/api';

class ClientsService {
  async findById(id) {
    const result = await api.get(`/clients/find/${id}`);

    return result.data;
  }

  async findByStatus(id) {
    const result = await api.get(`/clients/status/${id}`);

    return result.data;
  }

  async updateClient({
    id,
    name,
    dateOfBirth,
    description,
    cityId,
    profilePhoto,
    phone,
  }) {
    const result = await api.put(`/clients`, {
      id,
      name,
      dateOfBirth,
      description,
      cityId,
      profilePhoto,
      phone,
    });

    return result.data;
  }

  async getPresignedProfile(file) {
    const url = await api.post('/clients/profile', {
      filename: file.name,
      size: file.size,
    });

    return url.data;
  }

  // Verification methods
  async initiateVerification({ filename, size, type }) {
    const result = await api.post('/clients/verify/initiate', {
      filename,
      size,
      type,
    });

    return result.data;
  }

  async verifyEmail(code) {
    const result = await api.post('/clients/verify/email', {
      code,
    });

    return result.data;
  }

  async verifyPhone(code) {
    const result = await api.post('/clients/verify/phone', {
      code,
    });

    return result.data;
  }

  async verifyDocument(key) {
    const result = await api.post('/clients/verify/document', {
      key,
    });

    return result.data;
  }

  async getVerificationStatus() {
    const result = await api.get('/clients/verify/status');

    return result.data;
  }

  async listClients() {
    const result = await api.get('/clients');
    return result.data;
  }

  async findTotal() {
    const result = await api.get('/clients/total');
    return result.data;
  }

  async showClient(id) {
    const result = await api.get(`/clients/show/${id}`);
    return result.data;
  }

  async getLikes(id) {
    const result = await api.get(`/clients/likes/${id}`);
    return result.data;
  }

  async getFollowing(id) {
    const result = await api.get(`/clients/following/${id}`);
    return result.data;
  }

  async findByVerification(id) {
    const result = await api.get(`/clients/verification/${id}`);
    return result.data;
  }
}

export default new ClientsService();
